export default __webpack_public_path__ + "static/media/vmm_whitepaper.4f29c0d4.jpeg";